import { SubmitHandler } from 'react-hook-form';
import { FormData } from 'domains/client/ProfileSelectForm/schema';
import { useUserClientsLoggedIn } from 'domains/auth/UserClientsWrapper/useUserClients';
import { ProfileSelectUi } from './ui';

export const ProfileSelect = (): JSX.Element => {
  const { clients, changeClient, signOut, activeClientId } = useUserClientsLoggedIn();

  const onSubmit: SubmitHandler<FormData> = ({ clientID }) => changeClient(clientID);

  return <ProfileSelectUi activeClientId={activeClientId} clients={clients} onSubmit={onSubmit} onSignOut={signOut} />;
};
